var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search-purple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#5100FF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.6013,
    cy: 7.6013,
    r: 6.6013,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.147,
    x2: 15.794,
    y1: 13.311,
    y2: 17.479,
    strokeLinecap: "square",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPurple);
export default __webpack_public_path__ + "static/media/search-purple.c6958ed55d572cc0500a33ad61940fa4.svg";
export { ForwardRef as ReactComponent };